import { createFileRoute } from '@tanstack/react-router';
import { PlayingTimeView } from '@/components/PlayingTimeView';

export const Route = createFileRoute('/_authenticated/playing-time')({
  component: PlayingTimeView,
});

